// removed by extract-text-webpack-plugin
module.exports = {"entriesPanel":"cms__App__entriesPanel"};


//////////////////
// WEBPACK FOOTER
// ./containers/App.css
// module id = 592
// module chunks = 0